<script>
import { mapState, mapActions } from 'vuex';
/* components */
import Simplebar from 'simplebar-vue';
import EmptyTable from '@/components/EmptyTable';
import SvgIcon from '@/components/SvgIcon';
import ModalMobileTable from '@/components/modal/ModalMobileTable';
/*  */
import { applyLanguage } from '@/scripts/language';
import { getAvatar } from '@/scripts/utils';
import { DEFAULT_AVATAR } from '@/scripts/constants/constants';
import { getLeaderboardRowValue } from '@/scripts/methods';
import { mobile } from '@/scripts/computed';

export default {
  name: 'LeaderboardTable',
  components: {
    EmptyTable,
    ModalMobileTable,
    Simplebar,
    SvgIcon,
  },
  props: {
    head: {
      required: true,
    },
    body: {
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sortField: {
      type: String,
      default: '_rank',
    },
    sortDirection: {
      type: String,
      default: 'asc',
    },
    gameSetup: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isActive: false,
      modalData: null,
    };
  },
  computed: {
    ...mapState(['user', 'showModalLeaderboardData']),
    bodyFilled() {
      const { body, head } = this;
      const result = body && head && body.length && head.length;

      return result;
    },
    myStats() {
      const { body } = this;

      if (!body || !body.length) return null;

      const result = body.find(({ me }) => !!me);

      return result;
    },
    mobile,
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({
      toggleModalLeaderboardData: 'toggleModalLeaderboardData',
    }),
    getAvatarStyle(data, statsField) {
      const urlStorage = this.getLeaderboardRowValue(data, statsField, {
        subField: 'avatar',
      });
      const url = getAvatar(urlStorage);
      const result = {
        backgroundImage: `url(${url || DEFAULT_AVATAR})`,
      };

      return result;
    },
    getDisplayName(stats) {
      const { _player: player } = stats;
      const { displayName } = player;
      const result = displayName;

      return result;
    },
    getExternalStatsURL(stats) {
      const displayName = this.getDisplayName(stats);
      const { gameSetup } = this;
      const { externalStatsURL } = gameSetup;

      if (!externalStatsURL || !externalStatsURL.replace || !displayName)
        return null;

      const toReplace = '[DISPLAY_NAME]';

      const result = externalStatsURL.replace(toReplace, displayName);

      return result;
    },
    openExternalStats(allow, url) {
      if (!allow || !url) return;

      window.open(url, 'Your Stats');
    },
    rowClick(head, data) {
      const { mobile } = this;

      if (!mobile) return;

      this.modalData = data;
      this.toggleModalLeaderboardData(true);
    },
    getLeaderboardRowValue,
    getAvatar,
    applyLanguage,
  },
};
</script>

<template>
  <div class="leaderboard">
    <div class="leaderboard__table">
      <!--  -->
      <Simplebar data-simplebar-auto-hide="false" class="scroll">
        <div class="leaderboard__table-wrap" ref="drag">
          <table class="table">
            <!--  -->
            <thead>
              <tr>
                <!-- >map = 1 cell in head -->
                <th
                  v-for="{ caption, statsField } in head"
                  :key="caption"
                  :class="{
                    'is-active': sortField === statsField,
                    [sortDirection]: sortField === statsField,
                  }"
                  @click="$emit('sort', statsField)"
                >
                  <div class="head">
                    {{ caption }}
                    <div class="arrow">
                      <img :src="require('@/assets/svg/triangle-white.svg')" />
                    </div>
                  </div>
                </th>
                <!-- <map = 1 cell in head -->
              </tr>
            </thead>

            <!-- 1 -->
            <tbody v-if="bodyFilled">
              <!-- // -->

              <!-- >map = 1 row -->
              <tr
                v-for="(data, index) in body"
                :key="index"
                :class="{
                  row: true,
                  current: data.me && body.length > 1,
                }"
                @click="rowClick(head, data)"
              >
                <!-- >map = 1 cell -->
                <td
                  v-for="{ statsField, caption, units } in head"
                  :key="statsField"
                >
                  <div
                    :class="[
                      'data',
                      'data--' + statsField,
                      {
                        'data--winner':
                          mobile &&
                          getLeaderboardRowValue(data, '_rank') === `${1}`,
                      },
                    ]"
                  >
                    <!-- >rank/avatar/country -->
                    <div
                      class="data__avatar"
                      v-if="statsField === '_rank'"
                      :style="getAvatarStyle(data, '_player')"
                    >
                      <div class="data__country">
                        <SvgIcon
                          :name="
                            getLeaderboardRowValue(data, '_player', {
                              subField: 'country',
                            })
                          "
                        ></SvgIcon>
                      </div>
                    </div>
                    <!-- <rank/avatar/country -->

                    <!-- >universal -->
                    <div
                      :class="{
                        data__value: true,
                        'data__value--main':
                          getLeaderboardRowValue(data, '_rank') === `${1}`,
                        'is-link':
                          statsField === '_player' && getExternalStatsURL(data),
                      }"
                      @click="
                        openExternalStats(
                          statsField === '_player',
                          getExternalStatsURL(data)
                        )
                      "
                    >
                      <span>{{
                        getLeaderboardRowValue(data, statsField, { units })
                      }}</span>
                    </div>
                    <!-- <universal -->

                    <!-- TODO: rebuild -->
                    <!-- >mobile -->
                    <div class="data__mobile-content">
                      <!-- mobile displayName-->
                      <div v-if="statsField === '_rank'" class="data__name">
                        {{ getLeaderboardRowValue(data, '_player') }}
                      </div>
                      <!-- mobile earnings -->
                      <div v-if="statsField === '_rank'" class="data__coin">
                        {{ getLeaderboardRowValue(data, '_earnings') }} RUSH
                      </div>
                    </div>
                    <div class="data__arrow">
                      <img :src="require(`@/assets/svg/arrow-right.svg`)" />
                    </div>
                    <!-- <mobile -->
                  </div>
                </td>
                <!-- <map = 1 cell -->
              </tr>
              <!-- <map = 1 row -->
            </tbody>
            <!-- 2 -->
            <EmptyTable v-else :columns="head ? head.length : 0" />
          </table>
        </div>
      </Simplebar>
    </div>

    <!-- modal -->
    <ModalMobileTable
      v-if="mobile && modalData && showModalLeaderboardData"
      :head="head"
      :body="modalData"
      :avatar="getAvatarStyle(modalData, '_player')"
    />
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.leaderboard {
  &__table {
    overflow-x: hidden;
    width: 100%;
  }

  &__table-wrap {
    width: 100%;
    min-width: 1440px;
    padding-bottom: 20px;
  }

  &__list {
    display: none;
  }
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  thead {
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);
  }

  th {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.4);
    text-align: left;
    padding: 10px 20px;
    cursor: pointer;

    &.is-active {
      .head {
        .arrow {
          display: flex;
        }
      }

      &.asc {
        .head {
          .arrow {
            transform: rotate(-180deg);
          }
        }
      }
    }
  }

  .row {
    td {
      padding: 0;
      position: relative;

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 15px;
        left: 0;
        height: calc(100% - 15px);
        width: 100%;
        background: #232e33;
      }
    }

    td:first-child {
      &:before {
        border-top-left-radius: 18px;
        border-bottom-left-radius: 18px;
      }
    }

    td:last-child {
      &:before {
        border-top-right-radius: 18px;
        border-bottom-right-radius: 18px;
      }
    }

    &.current {
      td:before {
        height: calc(100% - 55px);
        top: 20px;
      }

      .data {
        margin-top: 20px;
        margin-bottom: 35px;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          bottom: -25px;
          left: 0;
          width: 100%;
          height: 1px;
          background: rgba(0, 184, 249, 0.5);
        }
      }
    }
  }

  .data {
    min-height: 70px;
    margin-top: 15px;
    display: flex;
    align-items: center;
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    padding: 5px 20px;
    display: flex;
    align-items: center;
    position: relative;

    &__avatar {
      position: relative;
      width: 50px;
      height: 50px;
      border-radius: 12px;
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.5);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      flex-shrink: 0;
      z-index: 1;
    }

    &__mobile-content {
      margin-left: 15px;
      display: none;
    }

    &__name {
      font-family: Poppins-Regular;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
    }

    &__coin {
      font-family: Poppins-Regular;
      font-size: 10px;
      line-height: 15px;
      color: rgba(255, 255, 255, 0.5);
      margin-top: 4px;
    }

    &__country {
      position: absolute;
      bottom: -1px;
      right: -4px;
      width: 13px;
      height: 13px;
      border-radius: 50%;
      overflow: hidden;
      background-position: center;
      background-size: cover;
      display: flex;
      align-items: center;

      .svg-icon {
        width: 100%;
        height: 100%;
        position: relative;
        -webkit-transform: scale(1.4);
        transform: scale(1.4);
      }
    }

    &__value {
      span {
        word-break: break-all;
      }

      &.is-link {
        cursor: pointer;
      }
    }

    &__arrow {
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      display: none;

      img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 6px;
        height: 9px;
      }
    }

    &.data--_rank {
      padding-left: 44px;

      .data__value {
        position: absolute;
        width: 71px;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        background-image: linear-gradient(
          to left,
          rgba(255, 255, 255, 0.06) 100%,
          #ffffff
        );
        border-top-left-radius: 18px;
        border-bottom-left-radius: 18px;
        border-top-right-radius: 24px;
        border-bottom-right-radius: 24px;

        span {
          width: 54px;
          text-align: center;
          padding: 5px 3px 5px 3px;
          word-break: break-all;
          position: relative;
          z-index: 1;
        }

        &--main {
          background: rgba(250, 217, 97, 0.2);
          background: -webkit-linear-gradient(
            right,
            rgba(250, 217, 97, 0.2),
            rgba(247, 109, 28, 0.2)
          );
          background: -moz-linear-gradient(
            right,
            rgba(250, 217, 97, 0.2),
            rgba(247, 109, 28, 0.2)
          );
          background: linear-gradient(
            to left,
            rgba(250, 217, 97, 0.2),
            rgba(247, 109, 28, 0.2)
          );
          color: #f69955;
          font-size: 20px;
          line-height: 28px;
        }
      }
    }
  }
}

.head {
  display: inline-block;
  position: relative;
  padding-right: 10px;
  transition: all 0.2s;

  &:hover {
    text-decoration: underline;
  }

  .arrow {
    position: absolute;
    right: -2px;
    top: 7px;
    display: none;
    transform: rotate(0);
    transition: all 0.2s;

    img {
      display: flex;
      align-items: center;
    }
  }
}

.arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7px;
  height: 5px;
  position: relative;
}

@media (max-width: $mobile) {
  .leaderboard {
    &__table-wrap {
      min-width: 100%;
      padding-bottom: 25px;
    }

    &__list {
      display: block;
    }
  }

  .table {
    thead {
      display: none;
    }

    .row {
      td:not(:first-child) {
        display: none;
      }

      td {
        &:before {
          display: none;
        }
      }

      &.current {
        .data {
          margin-top: 15px;
          margin-bottom: 45px;

          &:before {
            bottom: -30px;
          }
        }
      }
    }

    .data {
      min-height: 60px;
      background: #232e33;
      border-radius: 18px;

      &__avatar {
        width: 40px;
        height: 40px;
        border-radius: 9.6px;
        box-shadow: 0 3px 13px 0 rgba(0, 0, 0, 0.5);
      }

      &__mobile-content {
        display: block;
        margin-top: -2px;
      }

      &__arrow {
        display: flex;
      }

      &.data--_rank {
        padding-right: 30px;

        .data__value {
          width: 65px;

          span {
            width: 44px;
          }

          &--main {
            font-size: 14px;
            line-height: 20px;
            color: #ffffff;
          }
        }
      }

      &.data--winner {
        margin-left: 1px;
        margin-right: 1px;
        &:before {
          content: '';
          position: absolute;
          top: -1px;
          right: -1px;
          width: calc(100% + 2px);
          height: calc(100% + 2px);
          border-radius: 18px;
          background: rgba(250, 217, 97, 0.2);
          background: -webkit-gradient(
            linear,
            right top,
            left top,
            from(rgba(250, 217, 97, 0.2)),
            to(rgba(247, 109, 28, 0.2))
          );
          background: linear-gradient(
            to left,
            rgba(250, 217, 97, 0.2),
            rgba(247, 109, 28, 0.2)
          );
          z-index: -1;
        }
      }
    }
  }
}
</style>
